export default __webpack_public_path__ + "static/media/16418216951.9691ad64.JPG";